const zxcvbn = require('zxcvbn');

export default {
  required (name) {
    return v => !!v || `${name} is required`
  },
  password: v => (v && v.length >= 8) || 'The password must have at least 8 characters',
  confirm_password: (v, password) => {
    return (v && v === password) || 'The password does not match'
  },
  different_password: (v, old_password) => {
    return (v && v !== old_password) || 'The new password must be different from the old one'
  },
  strong_password: (v) => {
    v = v ?? '';
    const ret1 = zxcvbn(v);
    //issue 212
    var retbase =  ret1.score >= 3 || ret1.feedback?.warning || ret1.feedback?.suggestions[0];
    if (retbase === true)
    {
      /* eslint-disable */
      // bohhh nn va // var regularExpression = /^(?=.[a-z])(?=.[A-Z])(?=.\d)(?=.[@$!%?&])[A-Za-z\d@$!%?&]{8,}$/;
      // bohhh nn va // var regularExpression = /^(?=.[a-z])(?=.[A-Z])(?=.\d)(?=.[!£@#$%^&*()_\-+=\[\]{};:'",.<>?/\\|~])[A-Za-z\d!£@#$%^&*()_\-+=\[\]{};:'",.<>?/\\|~]{8,}$/;
      //var regularExpression = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
      var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~])[A-Za-z\d!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~]{8,}$/;
      /* eslint-disable */
      var retexprreg = regularExpression.test(v);
      if (retexprreg === false) 
      {
        return "The password must have minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character";
      }
      else
      {
        //se arrivo qui va bene !
        return true
      }
    }
    else
    {
      return retbase
    }
    //issue 212
  },
  email () {
    return v => /.+@.+/.test(v) || 'E-mail must be valid'
  },
  number (name) {
    return v => isFinite(v) || `${name} has to be a number`
  },
  username: [
    v => !!v || 'Username or Email is required',
  ],
  account: {
    email: [
      v => !!v || 'Email is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    password: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 8) || 'The password must have at least 8 characters'
    ],
    name: [
      v => !!v || 'Name is required'
    ],
    last_name: [
      v => !!v || 'Last name is required'
    ],
    role: [
      v => !!v || 'Role is required'
    ],
    phone: [
      v => !!v || 'Phone is required'
    ],
    status: [
      v => !!v || 'Status is required'
    ],
    privacy: [
      v => !!v || 'Privacy agree is required'
    ],
    site_id: [
      v => !!v || 'Site is required'
    ],
    city: [
      v => !!v || 'City is required'
    ],
  },
  protocol: [],
  roles: {
    group: [
      v => !!v || 'Group is required'
    ],
    name: [
      v => !!v || 'Name is required'
    ],
    description: [
      v => !!v || 'Desription is required'
    ],
    redcap_map: [
      v => !!v || 'Redcap map is required'
    ],
    safety_map: [
      v => !!v || 'Safety map is required'
    ],
    ecds_map: [
      v => !!v || 'Ecds map is required'
    ],
  }
}
